import { Box, Button, Card, Grid, Icon, TextField, Typography } from "@mui/material";
import DeleteIcon from "common/customIcons/delete";
import CommonQuillEditor from "common/editor";
import CustomInput from "components/common/CustomInput";
import MDButton from "components/MDButton";
import CommonLayout from "layouts/DashboardLayout";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { grey } from "@mui/material/colors";
import { slugRegex } from "utilities/common";
// import { openSnackbar } from "redux/slices/common";

const AddSubCategory = () => {
  const navigate= useNavigate()
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const id = queryParams.get("id");
  const dispatch = useDispatch();
  const [faqError, setFaqError] = useState("");
  const [isSlugData, setIsSlugData] = useState(false);
  const initialData = {
    metaTitle: "",
    metaDescription: "",
    heading: "",
    categoryName: "",
    content: "",
    faq: [{}],
    subCategorySlug: ""
  };
  const [subCategory, setSubCategory] = useState({ ...initialData });

  const [errors, setErrors] = useState({
    metaTitle: "",
    metaDescription: "",
  });
  const showError = (message, errortype) => {
    if (errortype === "success") {
      dispatch(openSnackbar({ content: message, color: "success", icon: "check" }));
    }
    if (errortype === "error") {
      dispatch(openSnackbar({ content: message, color: "error", icon: "warning" }));
    }
  };

  const validateForm = () => {
    let newErrors = {};

    if (!subCategory.metaTitle?.trim()) {
      newErrors.metaTitle = "Meta title is required";
    }

    if (!subCategory.metaDescription?.trim()) {
      newErrors.metaDescription = "Meta description is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };


  const handleChangeSlug = (e) => {
    const value = e.target.value;
    setIsSlugData(true);
    setSubCategory((prev) => ({ ...prev, subCategorySlug: slugRegex(value) }));
  };
  const handleSave = async () => {
    if (!validateForm()) {
      return;
    }
    // dispatch(updateSubCategory({ data: subCategory, id: id })).unwrap().then((res) => {
    //   showError(res?.message, 'success');
    //   navigate(-1);
    // }).catch((err) => {
    //   showError(err?.message, 'error');
    // });
  };

  // Faq functions
  const handleRemoveFAQ = (faQIdx) => {
    setFaqError("");
    let FAQArray = [...(subCategory?.faq || [])];
    FAQArray = FAQArray.filter((faqs, _idx) => _idx !== faQIdx);
    setSubCategory({
      ...subCategory,
      faq: FAQArray,
    });
  };

  const addFAQHandler = () => {
    if (!isLastFAQFilled()) {
      setFaqError("Please fill the previous FAQ before adding a new one.");
      return;
    }
    setFaqError("");
    let newFAQ = [...(subCategory?.faq || [])];
    let faqItem = {
      // question: "",
      // answer: "",
    };
    newFAQ.push(faqItem);
    setSubCategory({
      ...subCategory,
      faq: newFAQ,
    });
  };

  const handleChangeFAQ = (value, fieldType, idx) => {
    let FAQArray = [...(subCategory?.faq || [])];
    if (FAQArray[idx]) {
      FAQArray[idx] = {
        ...FAQArray[idx],
        [fieldType]: value,
      };
      setSubCategory({
        ...subCategory,
        faq: FAQArray,
      });
    }
  };

  const isLastFAQFilled = () => {
    const faqs = subCategory.faq || [];
    if (faqs.length === 0) return true;

    const last = faqs[faqs.length - 1];
    return Boolean(
      (last?.question && last.question.trim() !== "") || (last?.answer && last.answer.trim() !== "")
    );
  };


  // useEffect(() => {
  //   if (id) {
  //     dispatch(getSubCategoryData())
  //       .unwrap()
  //       .then((res) => {
  //         const data = res?.data;
  //         setSubCategory({
  //           metaTitle: data.metaTitle || "",
  //           metaDescription: data.metaDescription ||"",
  //           heading: data.heading || "",
  //           categoryName: data.category ||  "",
  //           content: data.content || "",
  //           faq: Array.isArray(data?.faq) ? data.faq : [],
  //           subCategorySlug: data.slug || "",
  //         });
  //       });
  //   }
  // }, [id]);

  return (
    <CommonLayout>
      <Box p={{ xs: 2, sm: 3, lg: 4 }}>
        <Card sx={{ p: { xs: 2, md: 3 }, mb: 1, borderRadius: 2.5, boxShadow: "none" }}>
          <Typography variant="h4" className="d-flex jc-ctr">
            {id ? "Update" : "Add"} Sub Category
          </Typography>
          <Grid item xs={12} mt={4}>
            <Grid container>
              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={6}>
                  <CustomInput
                    name="categoryName"
                    // disabled={true}
                    value={subCategory.categoryName}
                    onChange={(e) => {
                      setSubCategory((prev) => ({ ...prev, categoryName: e.target.value }));
                    }}
                    label="Category Name"
                    className="w-100"
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Sub Category Heading (H1)"
                    value={subCategory.heading}
                    fullWidth
                    variant="outlined"
                    onChange={(e) => {
                      setSubCategory((prev) => ({ ...prev, heading: e.target.value }));
                    }}
                    name="heading"
                    className="form-input"
                  />
                </Grid>
              </Grid>
              {id && (
                <Grid item xs={12} sm={6} mt={2}>
                  <TextField
                    className="form-input"
                    fullWidth
                    label="Sub Category Slug"
                    name="bmwCategorySlug"
                    value={subCategory.subCategorySlug}
                    onChange={handleChangeSlug}
                    //   disabled={category?.bmwCategorySlug === 'deals' ? true : false}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>

          <Typography variant="h5" fontWeight="semibold" mb={2} mt={4}>
            Meta Properties
          </Typography>

          <Grid container spacing={2.5}>
            <Grid item xs={12} sm={6} lg={4}>
              <TextField
                label="Meta Title"
                value={subCategory.metaTitle}
          
                fullWidth
                variant="outlined"
                onChange={(e) => {
                  const value = e.target.value;
                  setSubCategory((prev) => ({ ...prev, metaTitle: value }));
                  setErrors((prev) => ({ ...prev,metaTitle: value.trim() === "" ? "Meta title is required" : "" }));
                  
                }}
                error={Boolean(errors.metaTitle)}
                helperText={errors.metaTitle}
              />

              <span className="drag_drop">
                Character Count: {subCategory?.metaTitle?.length || 0}{" "}
                <span>(Recommended Characters: 60)</span>
              </span>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Meta Description"
                value={subCategory.metaDescription}
                fullWidth
                rows={4}
                variant="outlined"
                onChange={(e) => {
                  const value = e.target.value;
                  setSubCategory((prev) => ({ ...prev, metaDescription: value }));
                  setErrors((prev) => ({ ...prev, metaDescription: value.trim() === "" ? "Meta description is required" : "" }));
                }}
                error={Boolean(errors.metaDescription)}
                helperText={errors.metaDescription}
              />

              <span className="drag_drop">
                Character Count: {subCategory?.metaDescription?.length || 0}{" "}
                <span>(Recommended Characters: 160)</span>
              </span>
            </Grid>
          </Grid>

          <Typography variant="h5" fontWeight="semibold" mb={2} mt={2}>
            Content Section
          </Typography>
          <CommonQuillEditor
            value={subCategory?.content || ""}
            onChange={(value) => setSubCategory({ ...subCategory, content: value })}
          />

          <Typography variant="h5" fontWeight="semibold" mb={2} mt={4}>
            FAQs
          </Typography>

          {subCategory?.faq?.length > 0 ? (
            <>
              {subCategory?.faq?.map((faqs, idx) => {
                return (
                  <Grid key={idx} item xs={12} sm={12} lg={12} my={2}>
                    <Box width={"100%"} className="faq-sec-rep">
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="space-between"
                        alignItems={"flex-start"}
                        className="mb-3"
                      >
                        <Box
                          width={"100%"}
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          mb={1}
                        >
                          <Typography variant="body2" fontWeight="medium" color="#2E2E3A">
                            Question
                          </Typography>
                          <MDButton
                            sx={{ gap: 0.5 }}
                            size="small"
                            variant="text"
                            onClick={() => handleRemoveFAQ(idx)}
                            style={{ color: "#fd4438" }}
                          >
                            <DeleteIcon width="1rem" height="1rem" style={{ color: "#fd4438" }} />{" "}
                            Delete
                          </MDButton>
                        </Box>
                        <Box width={"100%"}>
                          <CommonQuillEditor
                            allowHeading={false}
                            allowImage={false}
                            value={faqs?.question || ""}
                            onChange={(value) => {
                              handleChangeFAQ(value, "question", idx);
                              setFaqError("");
                            }}
                          />
                        </Box>
                      </Box>
                      <Box display="flex" justifyContent="center" alignItems={"flex-start"}>
                        <Box width={"100%"}>
                          <Typography
                            variant="body2"
                            fontWeight="medium"
                            color="#2E2E3A"
                            mb={1}
                          >
                            Answer
                          </Typography>
                          <CommonQuillEditor
                            allowHeading={false}
                            allowImage={false}
                            value={faqs?.answer || ""}
                            onChange={(value) => {
                              handleChangeFAQ(value, "answer", idx);
                              setFaqError("");
                            }}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                );
              })}
            </>
          ) : (
            <Grid item xs={12} sm={12} lg={12} mt={3}>
              <Box display="flex" justifyContent="space-between" alignItems={"center"}>
                <MDButton
                  type="button"
                  color="primary"
                  size="medium"
                  variant="outlined"
                  sx={{ minWidth: "180px" }}
                  onClick={addFAQHandler}
                >
                  <Icon>add</Icon>&nbsp;Add FAQ
                </MDButton>
              </Box>
            </Grid>
          )}
          {faqError && (
            <Typography color="error" variant="body2" mb={1}>
              {faqError}
            </Typography>
          )}

          {subCategory?.faq?.length > 0 && (
            <Grid item xs={12} mt={3}>
              <MDButton
                type="button"
                color="primary"
                size="medium"
                variant="outlined"
                sx={{ minWidth: "180px" }}
                onClick={addFAQHandler}
              >
                <Icon>add</Icon>&nbsp;Add More
              </MDButton>
            </Grid>
          )}
        </Card>

        <Box textAlign="end" mt={2} display="flex" justifyContent="flex-end" gap={1}>
          <Button
            //   disabled={loading}
            variant="contained"
            color="primary"
            onClick={handleSave}
            style={{ minWidth: "160px" }}
          >
            Submit
          </Button>
          <MDButton
          // size="medium"
          variant="outlined"
          color="error"
          
          // sx={{ width: 140 }}
          style={{ minWidth: "160px" }}
          onClick={() => {
           navigate(-1)
          }}
        >
          Cancel
        </MDButton>
        </Box>
      </Box>
      {/* SubCategory */}
    </CommonLayout>
  );
};

export default AddSubCategory;
